document.addEventListener("DOMContentLoaded", () => {
	// /** Components */
	if (document.querySelector(".picture")) {
		import("./components/picture").then((module) => module.default.init());
	}

	if (document.querySelector(".call-to-action-quote-block")) {
		import("./components/callToActionQuote").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".hero")) {
		import("./components/hero").then((module) => module.default.init());
	}

	if (
		document.querySelector(".hero__video-container") ||
		document.querySelector(".hero-video-modal")
	) {
		import("./components/heroVideo").then((module) => module.default.init());
	}

	if (
		document.querySelector(".layout__divider") &&
		document.querySelector(".layout__sidebar")
	) {
		import("./components/sidebarPosition").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".side-navigation__item")) {
		import("./components/sideNavigation").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".styleguide-themes .header")) {
		import("./components/styleguide").then((module) => module.default.init());
	}

	if (document.querySelector(".accordion")) {
		import("./components/accordion").then((module) => module.default.init());
	}

	if (document.querySelector(".input-group--has-unit")) {
		import("./components/inputs").then((module) => module.default.init());
	}

	if (document.querySelector("[data-action='redirect']")) {
		import("./components/redirect").then((module) => module.default.init());
	}

	if (document.querySelector(".fake-select")) {
		import("./components/fakeSelect").then((module) => module.default.init());
	}

	if (document.querySelector(".to-top-button")) {
		import("./components/toTopArrow").then((module) => module.default.init());
	}

	if (document.querySelector(".navigation-mobile")) {
		import("./components/mobileNavigation").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".fake-select-tabs")) {
		import("./components/fakeSelectTabs").then((module) =>
			module.default.init(),
		);
	}
	if (document.querySelector(".header__links--language")) {
		import("./components/languageSwitcher").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".applications-block__download")) {
		import("./components/download").then((module) => module.default.init());
	}

	if (document.querySelector(".loan-calculator")) {
		import("./components/loanCalculator").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".dpicker")) {
		import("./components/datepicker").then((module) => module.default.init());
	}

	if (document.querySelector(".private-savings-calculator-block")) {
		import("./components/simplePrivateSavingsCalculator").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".accrued-rights-calculator-block")) {
		import("./components/accruedRightsCalculator").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".rotating-text-block")) {
		import("./components/rotatingTextBlock").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".form")) {
		import("./components/form").then((module) => module.default.init());
	}

	if (document.querySelector(".auth-login")) {
		import("./components/authForm").then((module) => module.default.init());
	}

	if (document.querySelector(".search-popup")) {
		import("./components/searchPopup").then((module) => module.default.init());
	}

	if (document.querySelector(".image-modal__content-container")) {
		import("./components/imageModal").then((module) => module.default.init());
	}

	if (document.querySelector(".search")) {
		import("./components/searchPage").then((module) => module.default.init());
	}

	if (
		document.querySelector(".call-to-action-block") ||
		document.querySelector(".newsletter-block") ||
		document.querySelector(".subpage-card") ||
		document.querySelector(".call-to-action-quote-block")
	) {
		import("./components/iconAnimations").then((module) =>
			module.default.init(),
		);
	}

	// /** Utility */
	if (document.querySelector(".canContainApiWords")) {
		import("utility/richtextApi").then((module) => module.default.init());
	}

	if (document.querySelector(".canContainTooltipWords")) {
		import("utility/richtextTooltip").then((module) => module.default.init());
	}
	if (document.querySelector(".tooltip")) {
		import("utility/tooltip").then((module) => module.default.init());
	}

	// if (document.querySelector('.styleguide-charts')) {
	//   import('components/test').then((module) => module.default.init())
	// }

	if (document.querySelector(".graph-block")) {
		import("components/graphs/graph").then((module) => module.default.init());
	}
	if (document.querySelector(".video-gallery-block")) {
		import("components/videoGalleryVideo").then((module) =>
			module.default.init(),
		);
	}

	// if (document.querySelector('.loan-calculator')) {
	//   loanStore.subscribe((sData) => Chart.init(sData.loanData))
	// }

	if (document.querySelector(".co-trigger")) {
		import("utility/clickoutside").then((module) => {
			return module.default(async () => {
				const iframe = document.querySelector(".hero-video-modal__video");
				const parent = iframe.parentElement.parentElement;
				const toggleModal = (await import("components/heroVideo")).default;

				if (iframe && parent.classList.contains("open")) {
					toggleModal.toggleVideoModal(toggleModal.el.modal);
				}
			});
		});
	}

	setTimeout((): void => {
		document.querySelector(".body").classList.remove("preload");
	}, 250);
});
